

function TitleListContent({ array }) {
    return (
        <>
            {array.length === 0 ?
                <div className='flex flex-col items-center justify-center w-full h-full mt-20'>
                    <img src="/image/Dashboard/notFound.png" className='w-28' />
                    <p className='mt-10 t-purpleDark font-bold'>متاسفانه موردی یافت نشد</p>
                </div>
                :
                <div className="flex flex-row-reverse bg-purpleDark text-white w-full py-2 rounded-t-lg">
                    <p className="w-12 text-right"></p>
                    <p className="w-40 mr-1 text-right">نام کانال</p>
                    <p className="w-40 mr-1 text-right">ادمین</p>
                    <p className="w-96 text-right">متن</p>
                    <p className="w-40 text-right">تاریخ</p>
                    <p className="w-40 text-right">ساعت</p>
                </div>
            }
        </>
    )
}
export default TitleListContent;